module.exports = __webpack_public_path__ + "static/media/ico_simulation_nose_lip_chin.202fca30.png";